import { Database } from './database';
import { Service, ServiceResponse } from './service';

export class DatabaseService extends Service {
  constructor() {
    super();
  }

  public async init(): Promise<ServiceResponse> {
    let params = null;
    let version = window.localStorage.getItem('AssetsDatabaseVersion');
    if(version)
      params = {version};

    let response = await this.sendCommand('public', 'get-assets', params);
    if(response.status != 200)
      return {success: false};

    if(!response.body.assets) {
      let assets = window.localStorage.getItem('AssetsDatabase');
      Database.assets = JSON.parse(assets);
      return {success: true}
    }

    let dbAssets = response.body.assets;

    let assets = [];
    for(let assetType in dbAssets) {
      for(let assetCategory in dbAssets[assetType]) {
        for(let i = 0; i < dbAssets[assetType][assetCategory].length; i++) {
          let asset = {...dbAssets[assetType][assetCategory][i]};
          asset.type = assetType;
          asset.category = assetCategory;
          assets.push(asset);
        }
      }
    }

    Database.assets = assets;

    window.localStorage.setItem('AssetsDatabaseVersion', response.body.version)
    window.localStorage.setItem('AssetsDatabase', JSON.stringify(assets))
  
    return {success: true};
  }
}
